import React, { Fragment, useEffect, useState } from "react";
import { ShoppingBag, Download, AlertCircle } from "react-feather";
import { Media } from "reactstrap";

import customAxios from '../../../customAxios';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSingleOrderList } from "../../../redux/actions/OrderActions";


const Notification = ({ item, onClick }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const NavigateToOrder = (res) => {
		if (res?.screen !== "order") return;
		const rightId = res?.order?._id ?? res?.order_id;
		if (!rightId) return;
		dispatch(getSingleOrderList(rightId));
		navigate(`/order/orderCustomerDetails/${rightId}`);
	}

	console.log(item, 'ITEM')


	return (
		<Fragment>
			<ul className="notification-dropdown onhover-show-div p-0" style={{ maxHeight: '300px', overflowY: 'auto' }} >
				<li>
					Notification{" "}
					<span className="badge rounded-pill badge-primary pull-right">{item?.count}</span>
				</li>
				{item?.data?.map((res, index) => (
					<li key={index} onClick={() => NavigateToOrder(res)} style={{ cursor: 'pointer' }}>
						<Media>
							<Media body>
								<h6 className="mt-0">
									{res?.name}
								</h6>
								<p className="mb-0">{res?.description}</p>
							</Media>
						</Media>
					</li>
				))}
			</ul>
		</Fragment>

	);
};

export default Notification;
